var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Depot from '../_shared/depot';
const removeFillFromSVG = (element) => {
    const _a = element.props, { fill, children } = _a, rest = __rest(_a, ["fill", "children"]);
    const newChildren = Array.isArray(children)
        ? children.map((child) => {
            const _a = child.props, { fill: fillChildren } = _a, restChildren = __rest(_a, ["fill"]);
            return Object.assign(Object.assign({}, child), { props: restChildren });
        })
        : children;
    return Object.assign(Object.assign({}, element), { props: Object.assign({ children: newChildren }, rest) });
};
const Icon = (_a) => {
    var { source, size = 24, fill = 'currentColor' } = _a, commonProps = __rest(_a, ["source", "size", "fill"]);
    let children;
    /* Preparing the content to remove any fill in the paths and recomposing the svg tag ourselves */
    React.Children.forEach(source.content, (child) => {
        if (child.type === 'svg') {
            if (Array.isArray(child.props.children)) {
                children = child.props.children.map((item) => removeFillFromSVG(item));
            }
            else {
                children = removeFillFromSVG(child.props.children);
            }
        }
    });
    const altText = (source === null || source === void 0 ? void 0 : source.alt) || 'Icon';
    return Depot.createElement(source.type, Object.assign(Object.assign({}, commonProps), { fill, viewBox: '0 0 24 24', height: `${size}px`, width: `${size}px`, role: 'img', id: altText }), React.createElement(React.Fragment, null,
        React.createElement("title", null, altText),
        React.createElement("desc", null, altText),
        children));
};
export default Icon;
//# sourceMappingURL=index.js.map